module.exports = __webpack_public_path__ + "static/media/02-1-galeria-03-saint-laurent-mobile@2x.e0a9c510.jpg";